export const PRICE_LEVELS = ["Matala", "Keskihintainen", "Korkea"];

export const normalizePriceLevel = (priceLevel) => {
  return (
    PRICE_LEVELS.find(
      (allowedPriceLevel) =>
        allowedPriceLevel.toLowerCase() ===
        priceLevel?.toString().toLowerCase(),
    ) ?? priceLevel
  );
};

export const getValidPriceLevels = (priceLevels = []) => {
  if (!Array.isArray(priceLevels)) {
    return [];
  }

  return [
    ...new Set(
      priceLevels
        .map(normalizePriceLevel)
        .filter((priceLevel) => PRICE_LEVELS.includes(priceLevel)),
    ),
  ];
};
